import BaseController from "confinus_ui/base_controller";

// Disables the shipping-address fields while "same as billing" is checked, so
// they are not submitted. Replaces a one-shot inline <script> that no longer
// executes under Turbo Drive body-swaps. Wire-up:
//
//   <div data-controller="same-as-billing"
//        data-action="change->same-as-billing#toggle">
//     ... <checkbox name="...[same_as_billing_address]"> ...
//     <div data-same-as-billing-target="fields"> ...shipping fields... </div>
//   </div>
const DECOR_FIELD_SELECTOR =
  '[data-controller~="decor--suite--forms--text-field"],' +
  '[data-controller~="decor--suite--forms--select"]';

export default class SameAsBillingController extends BaseController {
  public static targets = ["fields"];

  declare private readonly fieldsTarget: HTMLElement;
  declare private readonly hasFieldsTarget: boolean;

  public connect(): void {
    this.apply();
  }

  public toggle(event: Event): void {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== "checkbox")
      return;
    if (!input.name.endsWith("[same_as_billing_address]")) return;
    this.apply();
  }

  private apply(): void {
    if (!this.hasFieldsTarget) return;
    const checkbox = this.element.querySelector<HTMLInputElement>(
      'input[type="checkbox"][name$="[same_as_billing_address]"]',
    );
    if (!checkbox) return;
    const disabled = checkbox.checked;

    this.fieldsTarget
      .querySelectorAll<HTMLInputElement | HTMLSelectElement>("input, select")
      .forEach((el) => {
        el.disabled = disabled;
      });
    this.fieldsTarget
      .querySelectorAll<HTMLElement>(DECOR_FIELD_SELECTOR)
      .forEach((el) => {
        if (disabled) {
          el.setAttribute("disabled", "disabled");
        } else {
          el.removeAttribute("disabled");
        }
      });
  }
}
